import notificationTypes from '../../config/notificationTypes'

import ClientNotificationInterface from '../../interfaces/client/Notification'

export default (notifications: ClientNotificationInterface[]) =>
  notifications.filter(
    (notification: ClientNotificationInterface) =>
      notification.type === notificationTypes.error && notification.isGlobal
  )
